const PHOTOS = [
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/s5a321dk_WhatsApp%20Image%202026-05-30%20at%208.54.52%20PM%20%284%29.jpeg",
    caption: "Farm Hub Site Inspection · Niger State Rice Fields",
    span: "md:col-span-7",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/ccez06mq_WhatsApp%20Image%202026-05-30%20at%208.54.53%20PM%20%281%29.jpeg",
    caption: "Keynote Address · Agrovest Launch Press Briefing",
    span: "md:col-span-5",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/ujasa4t6_WhatsApp%20Image%202026-05-30%20at%208.54.55%20PM.jpeg",
    caption: "Strategic Partners · 20 Million Naira & Rwanda Trip Reveal",
    span: "md:col-span-6",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/c7uzjnij_WhatsApp%20Image%202026-05-30%20at%208.54.52%20PM%20%281%29.jpeg",
    caption: "Live Press Conference · Cameras & Audience, Abuja",
    span: "md:col-span-6",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/fvhavasl_WhatsApp%20Image%202026-05-30%20at%208.54.55%20PM%20%281%29.jpeg",
    caption: "Partner Panel · Press Conference Q&A",
    span: "md:col-span-5",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/ifke8c3v_WhatsApp%20Image%202026-05-30%20at%208.54.52%20PM%20%282%29.jpeg",
    caption: "Live Media Briefing · NTA & Arise News Coverage",
    span: "md:col-span-7",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/2tbpsgd9_WhatsApp%20Image%202026-05-30%20at%208.54.52%20PM.jpeg",
    caption: "Sydani Group Delegation · Strategic Partner Engagement",
    span: "md:col-span-5",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/ts9zxawy_WhatsApp%20Image%202026-05-30%20at%208.54.57%20PM%20%281%29.jpeg",
    caption: "Programme Strategy Roundtable · Agrovest Team",
    span: "md:col-span-7",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_41fcd887-8ec6-40f9-b180-4549d29a6fe7/artifacts/qodzm69a_514355381_754040930458457_7600060261891631209_n.jpg",
    caption: "Agrovest Reality TV Show · Opening Ceremony, Minna",
    span: "md:col-span-8",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_41fcd887-8ec6-40f9-b180-4549d29a6fe7/artifacts/egnnf30h_514264654_755016043694279_8104147121727981257_n.jpg",
    caption: "Strategic Partners Roundtable · 20 Million Naira Reveal",
    span: "md:col-span-4",
  },
];

export default function Gallery() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-5">
        Gallery
      </div>
      <h1
        className="text-4xl sm:text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] mb-10 sm:mb-14"
        style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
      >
        A glimpse into<br />
        our <span className="text-[#F26A1F]">journey</span>.
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-3">
        {PHOTOS.map((p) => (
          <figure
            key={p.url}
            className={`${p.span || "md:col-span-4"} relative overflow-hidden border border-white/10 group bg-black`}
          >
            <img
              src={p.url}
              alt={p.caption}
              loading="lazy"
              className="w-full h-64 sm:h-72 object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/60 to-transparent p-4 text-xs text-white/85">
              {p.caption}
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
